export default "__VITE_ASSET__CTh_5bKS__"